export const DEFAULT_SIZE = {
  width: 376,
  height: 600,
};

export const NOTIFICATIONS_INTERVAL_TIME = 1000;

export const MAX_NAME_LENGTH = 30;

export const RICH_CONTENT_V2 = 'RICH_CONTENT_V2';

export const THREAD_ITEM_TYPE = {
  AGENT_JOINED: 'agent_joined',
  DIVIDER: 'divider',
  PRELOADER: 'preloader',
};

export const DIALOG_END_REASON = {
  QUEUE_WAIT_TIMEOUT: 'queue_wait_timeout',
};
